import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '@uhg-abyss/web/ui/Card';
import { usePPDLagoon } from '../../tools/lagoon';
import { RenderHtml } from '@sde/widgets-core/src/common/RenderHtml';

export const DataCard = ({ title, configKey }) => {
  const { getMessage } = usePPDLagoon();

  const message = getMessage(configKey);

  return (
    <Card header={title}>
      <Card.Section>
        <RenderHtml>{message}</RenderHtml>
      </Card.Section>
    </Card>
  );
};

DataCard.propTypes = {
  title: PropTypes.string,
  configKey: PropTypes.string.isRequired,
};

DataCard.defaultProps = {
  title: null,
};
